export enum FilterPickerFilterName {
  Bool = 'fp-bools',
  Date = 'fp-dates',
  Number = 'fp-numbers',
  Search = 'fp-search',
  Select = 'fp-selects',
  String = 'fp-strings'
}
